// src/components/assessment/AssessmentScreens.jsx
import React from 'react';
import { Scan, Brain, CheckCircle2 } from 'lucide-react';

// The way in (welcome + intro) now lives in ./AssessmentStart.jsx.

// Between the answers and the coach conversation: the gate asks, the active
// state explains what the panel is doing. Plain words; the member is not a
// specimen and nothing here was "detected".
export const AssessmentGate = ({ stage, onNext, onSkip }) => (
    <div className="flex flex-col h-full overflow-hidden">
        <div className="flex-1 overflow-y-auto p-6 flex flex-col items-center justify-center text-center animate-in fade-in duration-700">
            <div className="relative">
                <div className="absolute inset-0 bg-teal-500/20 rounded-full blur-xl animate-pulse"></div>
                <div className="w-24 h-24 md:w-32 md:h-32 bg-white border-4 border-teal-500 text-teal-600 rounded-full flex items-center justify-center mb-8 shadow-2xl relative z-10">
                    {stage === 'clinical_gate' ? <Scan size={40} className="md:w-12 md:h-12 animate-pulse" /> : <Brain size={40} className="md:w-12 md:h-12 text-teal-600" />}
                </div>
            </div>
            <h2 className="text-2xl md:text-3xl font-black text-slate-800 mb-4 tracking-tight">
                 {stage === 'clinical_gate' ? "A few more questions" : "A quick conversation"}
            </h2>
            <div className="max-w-md bg-slate-50 p-6 rounded-2xl border border-slate-100">
                <p className="text-slate-500 text-base md:text-lg leading-relaxed font-medium">
                    {stage === 'clinical_gate'
                         ? "Your answers point at one area worth a closer look. A short chat with the coach panel builds your plan around it."
                         : "The coach panel is asking a few questions about it. Answer in your own words."}
                </p>
            </div>
        </div>
        {stage === 'clinical_gate' && (
            <div className="p-4 bg-white border-t border-slate-100 shrink-0 z-20 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] flex flex-col gap-2 md:hidden">
                 <button onClick={onNext} className="w-full bg-teal-600 text-white py-4 rounded-xl font-bold shadow-lg flex items-center justify-center gap-2">
                     <CheckCircle2 size={18} /> Continue
                 </button>
                 <button onClick={onSkip} className="w-full bg-slate-50 text-slate-400 py-3 rounded-xl font-bold text-xs">
                     Skip this
                 </button>
            </div>
        )}
    </div>
);

// AssessmentComplete now lives in ./AssessmentComplete.jsx
